"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringValueOrNull = exports.isUndefinedValue = exports.isOptimizedTrueValue = exports.isBooleanValue = exports.isNumberValue = exports.isStringValue = exports.isNullValue = void 0;
const isNullValue = (fieldValue) => fieldValue === null;
exports.isNullValue = isNullValue;
const isStringValue = (fieldValue) => typeof fieldValue === "string";
exports.isStringValue = isStringValue;
const isNumberValue = (fieldValue) => typeof fieldValue === "number";
exports.isNumberValue = isNumberValue;
const isBooleanValue = (fieldValue) => typeof fieldValue === "boolean";
exports.isBooleanValue = isBooleanValue;
const isOptimizedTrueValue = (fieldValue) => fieldValue === 1;
exports.isOptimizedTrueValue = isOptimizedTrueValue;
const isUndefinedValue = (fieldValue) => typeof fieldValue === "undefined";
exports.isUndefinedValue = isUndefinedValue;
const isStringValueOrNull = (fieldValue) => (0, exports.isStringValue)(fieldValue) ||
    (0, exports.isNullValue)(fieldValue) ||
    (0, exports.isUndefinedValue)(fieldValue);
exports.isStringValueOrNull = isStringValueOrNull;
